export const shouldAppendFormDataValue = value => {
  if (value === undefined || value === null) {
    return false
  }

  if (typeof value === 'string') {
    const normalizedValue = value.trim()
    return normalizedValue !== '' && normalizedValue.toLowerCase() !== 'undefined'
  }

  return true
}

export const appendFormDataValue = (formData, key, value) => {
  if (!shouldAppendFormDataValue(value)) {
    return
  }

  formData.append(key, typeof value === 'string' ? value.trim() : value)
}
